import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Modalizer from 'components/modalizer/modalizer'
import { connect } from 'react-redux'

import storefrontActions from 'redux/actions/storefrontActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { myAccountSelectors } from 'redux/selectors'
import SubjectsGradesTeacherForm from '../../owner/components/forms/subjects_grades_teacher_form'
import modalTypes from 'helpers/enums/modalTypes'

class StoreFrontGradesSubjectsModal extends Component {

	render() {
		return (
			<div>
				{this.props.userDataLoaded &&
				<Modalizer modalName={modalTypes.STOREFRONT_GRADES_SUBJECTS_PICKER} width='552px' closeAction={this.props.actions.closeModal}>
					<SubjectsGradesTeacherForm
						initialValues={{
							gradeIds: this.props.userData.gradeIds,
							subjectIds: this.props.userData.subjectIds,
						}}
						saveTeacherInfo={this.props.actions.saveGradesAndSubjects}
						grades={this.props.userData.grades}
						gradeIds={this.props.userData.gradeIds}
						subjects={this.props.userData.subjects}
						subjectIds={this.props.userData.subjectIds}
						cancel={this.props.actions.cancel}
					/>
				</Modalizer>
				}
			</div>
		)
	}
}

StoreFrontGradesSubjectsModal.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return myAccountSelectors.profileViewSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: storefrontActions.subjectsGradesModalClose,
		saveGradesAndSubjects: storefrontActions.saveTeacherInfo,
		cancel: storefrontActions.subjectsGradesModalCancel,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreFrontGradesSubjectsModal)
